// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_uE9","col":"styles_col__2s3n6"};